import React from 'react';
import { Moment } from 'moment';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { PlusCircleOutlined } from '@ant-design/icons';

import FormItem from '@/components/ui/FormItem';
import InputText from '@/components/ui/InputText';
import { AddButton } from '../TaskItem/AddButton';
import { useTaskForm } from './_hooks/useTaskForm';
import { DueDateDropdown } from '../TaskItem/DueDateDropdown';
import { ResponsibleDropdown } from '../TaskItem/ResponsibleDropdown';

interface TaskFormProps {
	users: { value: string; label: string }[];
	limitDate?: Moment;
	onAddTask: (values: any) => void;
	modal?: boolean;
}

export function TaskForm({ users = [], limitDate, onAddTask, modal = false }: Readonly<TaskFormProps>): JSX.Element {
	const { form, handleOnClick } = useTaskForm({ onAddTask });

	return (
		<Form form={form} layout="vertical">
			<Row justify="space-around" gutter={6}>
				<Col span={modal ? 18 : 20}>
					<FormItem name="title" rules={[{ required: true, message: I18n.get('Task Name is required') }]}>
						<InputText placeholder="Task Name" />
					</FormItem>
				</Col>
				<Col>
					<DueDateDropdown fieldName="due_date" limitDate={limitDate} />
				</Col>
				<Col>
					<ResponsibleDropdown fieldName="responsible_user_id" options={users} />
				</Col>
				<Col>
					<AddButton type="primary" onClick={handleOnClick} icon={<PlusCircleOutlined />} />
				</Col>
			</Row>
		</Form>
	);
}
